import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { Loader2, Trophy } from "lucide-react";
import api from "@/lib/api";

export default function NextGenStubLogin() {
  const [params] = useSearchParams();
  const [athleteId, setAthleteId] = useState("");
  const [busy, setBusy] = useState(false);

  const authorize = async () => {
    if (!athleteId.trim()) return toast.error("Enter your athlete ID");
    setBusy(true);
    try {
      const { data } = await api.post("/sport/link/stub-authorize", { state: params.get("state"), athlete_id: athleteId });
      window.location.assign(data.redirect);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Authorization failed");
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0B1F3A] text-white flex items-center justify-center px-6">
      <div data-testid="nextgen-stub-login" className="max-w-sm w-full rounded-2xl bg-white/5 border border-white/10 p-7">
        <div className="flex items-center gap-2 text-sky-300 text-xs font-semibold uppercase tracking-widest">
          <Trophy className="h-4 w-4" /> NextGen · Talanta Sport
        </div>
        <h1 className="mt-2 font-display font-bold text-2xl">Sign in to authorize</h1>
        <p className="mt-1 text-sm text-white/60">
          <span className="font-semibold text-talanta-gold">Talanta Hela</span> wants to link your athlete profile. This is the integration stand-in until NextGen SSO is live.
        </p>
        <label className="mt-5 block text-xs font-semibold uppercase tracking-wider text-white/50">Athlete ID</label>
        <input
          data-testid="stub-athlete-id-input"
          value={athleteId}
          onChange={(e) => setAthleteId(e.target.value)}
          placeholder="e.g. ath-1001"
          className="mt-1.5 w-full rounded-xl bg-white/10 border border-white/15 px-4 py-3 outline-none focus:ring-2 focus:ring-sky-400 font-mono"
          onKeyDown={(e) => e.key === "Enter" && authorize()}
        />
        <p className="mt-1.5 text-[11px] text-white/40">Test IDs: ath-1001 … ath-1007</p>
        <button
          data-testid="stub-authorize-btn"
          onClick={authorize}
          disabled={busy}
          className="mt-5 w-full rounded-xl bg-sky-500 hover:bg-sky-400 py-3 font-semibold flex items-center justify-center gap-2 disabled:opacity-60"
        >
          {busy ? <Loader2 className="h-5 w-5 animate-spin" /> : "Authorize Talanta Hela"}
        </button>
      </div>
    </div>
  );
}
